module.exports = __webpack_public_path__ + "img/code.29bb04a9.png";